import { lazy } from "react";
import Loadable from "app/components/Loadable";

// Lazy loading components with Loadable for code splitting
const AppDetails = Loadable(lazy(() => import("./details/details")));
const AppStudent = Loadable(lazy(() => import("./student/student")));
const EditStudentPage = Loadable(lazy(() => import("./edit_student/EditStudentPage")));
const AddTeacherForm = Loadable(lazy(() => import("./AddTeacher/AddTeacherForm")));
const ViewTeacher = Loadable(lazy(() => import("./ViewTeacher/ViewTeacher")));
const EditTeacher = Loadable(lazy(() => import("./edit_teacher/EditTeacher"))); // Import the EditTeacher component
const AddClassSection = Loadable(lazy(() => import("./AddClassSection/AddClassSection")));
const AddSubject = Loadable(lazy(() => import("./AddSubject/AddSubject")));
const AllocateTeacher = Loadable(lazy(() => import("./AllocateTeacher/AllocateTeacher")));
const AddAttendance = Loadable(lazy(() => import("./AddAttendance/AddAttendance")));
const AddMarks = Loadable(lazy(() => import("./AddMarks/AddMarks")));
const ViewStudentMarks = Loadable(lazy(() => import("./ViewStudentMarks/ViewStudentMarks")));
const ViewProfile = Loadable(lazy(() => import("./ViewProfile/ViewProfile")));
const ExamGroupManagement = Loadable(lazy(() => import("./ExamGroupManagement/ExamGroupManagement")));
const ExamList = Loadable(lazy(() => import("./ExamList/ExamList")));
const NewExam = Loadable(lazy(() => import("./NewExam/NewExam")));
const ExamTeacherGroup = Loadable(lazy(() => import("./ExamTeacherGroup/ExamTeacherGroup")));
const ExamTeacherList = Loadable(lazy(() => import("./ExamTeacherList/ExamTeacherList")));
const RemarksAttendance = Loadable(lazy(() => import("./Remarks_attendance/RemarksAttendance")));
const PersonalityProfile = Loadable(lazy(() => import("./PersonalityProfile/PersonalityProfile")));
const PersonalityProfileTeacher = Loadable(lazy(() => import("./PersonalityProfileTeacher/PersonalityProfileTeacher")));
const StudentPortal = Loadable(lazy(() => import("./StudentPortal/StudentPortal")));
const GradeSubject = Loadable(lazy(() => import("./GradeSubject/GradeSubject")));
const GradeSubjectTeacher = Loadable(lazy(() => import("./GradeSubjectTeacher/GradeSubjectTeacher")));
const AdminViewStudentMarks = Loadable(lazy(() => import("./AdminViewStudentMarks/AdminViewStudentMarks")));
const PrintMarksheet = Loadable(lazy(() => import("./PrintMarksheet/PrintMarksheet")));


const PrintTc = Loadable(lazy(() => import("./PrintTc/PrintTc")));
// const GenTC = Loadable(lazy(() => import("./GenTc/GenTc")));


const GenMarksheet = Loadable(lazy(() => import("./GenMarksheet/GenMarksheet")));
const GenMarksheet129 = Loadable(lazy(() => import("./GenMarksheet/GenMarksheet129")));
const MessageStudent = Loadable(lazy(() => import("./MessagingSystem/MessageStudent")));
const MessageStudentView = Loadable(lazy(() => import("./MessageStudentView/MessageStudentView")));
const ViewBooks = Loadable(lazy(() => import("./ViewBooks/ViewBooks")));
const MessageTeacher = Loadable(lazy(() => import("./MessagingSystemTeacher/MessageTeacher")));
const MessagingSystemTeacher = Loadable(lazy(() => import("./MessagingSystemTeacher/MessagingSystemTeacher")));
const MessagingSystem = Loadable(lazy(() => import("./MessagingSystem/MessagingSystem")));
const MessageTeacherView = Loadable(lazy(() => import("./MessageTeacherView/MessageTeacherView")));
const PromoteStudent = Loadable(lazy(() => import("./PromoteStudent/PromoteStudent")));
const LibrarianAddBook = Loadable(lazy(() => import("./LibrarianAddBook/LibrarianAddBook")));
const LibrarianDeleteBook = Loadable(lazy(() => import("./LibrarianDeleteBook/LibrarianDeleteBook")));
const LibrarianIssueBook = Loadable(lazy(() => import("./LibrarianIssueBook/LibrarianIssueBook")));
const LibrarianReturnBook = Loadable(lazy(() => import("./LibrarianReturnBook/LibrarianReturnBook")));
const LibrarianPayFine = Loadable(lazy(() => import("./LibrarianPayFine/LibrarianPayFine")));
const LibrarianMovementLog = Loadable(lazy(() => import("./LibrarianMovementLog/LibrarianMovementLog")));
const Assignment = Loadable(lazy(() => import("./Assignment/Assignment")));
const ViewAssignments = Loadable(lazy(() => import("./ViewAssignment/ViewAssignments")));
const ViewAssignment = Loadable(lazy(() => import("./ViewAssignment/StudentViewAssignment")));
const DownloadDetails = Loadable(lazy(() => import("./DownloadDetails/DownloadDetails")));
const AssignFeeStructure = Loadable(lazy(() => import("./fees/AssignFeeStructure")));
const RecordPayment = Loadable(lazy(() => import("./fees/RecordPayment")));
const UnpaidStatus = Loadable(lazy(() => import("./fees/UnpaidStatus")));
const ViewAndEditFeeStructure = Loadable(lazy(() => import("./fees/ViewAndEditFeeStructure")));
const FeesStudent = Loadable(lazy(() => import("./feesStudent/feesStudent")));
const AdminViewStudentFees = Loadable(lazy(() => import("./AdminViewStudentFees/AdminViewStudentFees")))
const AddLibrarianComment = Loadable(lazy(() => import("./AddLibrarianComment/AddLibrarianComment")))
const ViewLibrarianComment = Loadable(lazy(() => import("./ViewLibrarianComment/ViewLibrarianComment")))
const AdminViewDiary = Loadable(lazy(() => import("./AdminViewDiary/AdminViewDiary")))
const PreBoard = Loadable(lazy(() => import("./PreBoard/PreBoard")));
const PreBoard10 = Loadable(lazy(() => import("./PreBoard/PreBoard10")));
const PreBoard12 = Loadable(lazy(() => import("./PreBoard/PreBoard12")));
const LogSheet = Loadable(lazy(() => import("./LogSheet/LogSheet")));
const LogSheetDetailed = Loadable(lazy(() => import("./LogSheet/LogSheetDetailed")));

const TopRankers = Loadable(lazy(() => import("./LogSheet/TopRankers")));

const AddUser = Loadable(lazy(() => import("./AddUser/AddUser")));
const AddSession = Loadable(lazy(() => import("./AddSession/AddSession")));
const AttendanceRecordsDownload = Loadable(lazy(() => import("./AttendanceRecordsDownload/AttendanceRecordsDownload")));
const Certificate = Loadable(lazy(() => import("./Certificate/Certificate")));
const GenCertificate = Loadable(lazy(() => import("./Certificate/GenCertificate")));
const MarkSheetTemplate = Loadable(lazy(() => import("./MarkSheetTemplate/MarkSheetTemplate")));
// Define routes for the application
const materialRoutes = [
  { path: "/material/details", element: <AppDetails /> },
  { path: "/material/student", element: <AppStudent /> },
  { path: "/material/edit_student/:admission_no", element: <EditStudentPage /> }, // Route for editing a student
  { path: "/material/AddTeacher", element: <AddTeacherForm /> },
  { path: "/material/ViewTeacher", element: <ViewTeacher /> },
  { path: "/material/edit_teacher/:teacherId", element: <EditTeacher /> }, // New route for editing a teacher
  { path: "/material/AddClassSection", element: <AddClassSection /> },
  { path: "/material/AddSubject", element: <AddSubject /> },
  { path: "/material/AllocateTeacher", element: <AllocateTeacher /> },
  { path: "/material/AddAttendance", element: <AddAttendance /> },
  { path: "/material/AddMarks", element: <AddMarks /> },
  { path: "/material/ViewStudentMarks", element: <ViewStudentMarks /> },
  { path: "/material/ViewProfile", element: <ViewProfile /> },
  { path: "/material/ExamGroupManagement", element: <ExamGroupManagement /> },
  { path: "/material/ExamList/:termName", element: <ExamList /> },
  { path: "/material/NewExam/:termName", element: <NewExam /> },
  { path: "/material/ExamTeacherGroup", element: <ExamTeacherGroup /> },
  { path: "/material/ExamTeacherList/:termName", element: <ExamTeacherList /> },
  { path: "/material/Remarks_attendance/:term_id", element: <RemarksAttendance /> },
  { path: "/material/PersonalityProfile/:term_id", element: <PersonalityProfile /> },
  { path: "/material/PersonalityProfileTeacher/:term_id", element: <PersonalityProfileTeacher /> },
  { path: "/material/GradeSubject/:term_id", element: <GradeSubject /> },
  { path: "/material/GradeSubjectTeacher/:term_id", element: <GradeSubjectTeacher /> },
  { path: "/material/StudentPortal/:admissionNo", element: <StudentPortal /> },
  { path: "/material/AdminViewStudentMarks", element: <AdminViewStudentMarks /> },
  { path: "/material/PrintMarksheet", element: <PrintMarksheet /> },
  { path: "/material/GenMarksheet/:studentIds", element: <GenMarksheet /> },
  { path: "/material/GenMarksheet129/:studentIds", element: <GenMarksheet129 /> },


  { path: "/material/PrintTc", element: <PrintTc /> },
  // { path: "/material/GenTc/:studentIds", element: <GenTC /> },


  { path: "/material/MessageStudent", element: <MessageStudent /> },
  { path: "/material/MessageStudentView", element: <MessageStudentView /> },
  { path: "/material/ViewBooks", element: <ViewBooks /> },
  { path: "/material/MessageTeacher", element: <MessageTeacher /> },
  { path: "/material/MessagingSystemTeacher", element: <MessagingSystemTeacher /> },
  { path: "/material/MessagingSystem", element: <MessagingSystem /> },
  { path: "/material/MessageTeacherView", element: <MessageTeacherView /> },
  { path: "/material/PromoteStudent", element: <PromoteStudent /> },
  { path: "/material/LibrarianAddBook", element: <LibrarianAddBook /> },
  { path: "/material/LibrarianDeleteBook", element: <LibrarianDeleteBook /> },
  { path: "/material/LibrarianIssueBook", element: <LibrarianIssueBook /> },
  { path: "/material/LibrarianReturnBook", element: <LibrarianReturnBook /> },
  { path: "/material/LibrarianPayFine", element: <LibrarianPayFine /> },
  { path: "/material/LibrarianMovementLog", element: <LibrarianMovementLog /> },
  { path: "/material/Assignment", element: <Assignment /> },
  { path: "/material/ViewAssignments", element: <ViewAssignments /> },
  { path: "/material/ViewAssignment", element: <ViewAssignment /> },
  { path: "/material/DownloadDetails", element: <DownloadDetails /> },
  { path: "/material/fees/AssignFeeStructure", element: <AssignFeeStructure /> },
  { path: "/material/fees/RecordPayment", element: <RecordPayment /> },
  { path: "/material/fees/UnpaidStatus", element: <UnpaidStatus /> },
  { path: "/material/fees/ViewAndEditFeeStructure", element: <ViewAndEditFeeStructure /> },
  { path: "/material/feesStudent", element: <FeesStudent /> },
  { path: "/material/AdminViewStudentFees/:admissionNo", element: <AdminViewStudentFees /> },
  { path: "/material/AddLibrarianComment", element: <AddLibrarianComment /> },
  { path: "/material/ViewLibrarianComment", element: <ViewLibrarianComment /> },
  { path: "/material/AdminViewDiary/:admissionNo", element: <AdminViewDiary /> },


  { path: "/material/LogSheet", element: <LogSheet /> },
  { path: "/material/LogSheetDetailed", element: <LogSheetDetailed /> },
  { path: "/material/TopRankers", element: <TopRankers /> },


  { path: "/material/AddUser", element: <AddUser /> },


  { path: "/material/AddSession", element: <AddSession /> },
  { path: "/material/PreBoard", element: <PreBoard /> },
  { path: "/material/PreBoard10/:studentIds", element: <PreBoard10 /> },
  { path: "/material/PreBoard12/:studentIds", element: <PreBoard12 /> },
  { path: "/material/AttendanceRecordsDownload", element: <AttendanceRecordsDownload /> },
  { path: "/material/Certificate", element: <Certificate /> },
  { path: "/material/GenCertificate/:ids", element: <GenCertificate /> },
  { path: "/material/MarkSheetTemplate", element: <MarkSheetTemplate /> },
];

export default materialRoutes;  